import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import Http from 'axios';
import Config from "../config";
export default {
  attemptLogin: function attemptLogin(credentials) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 1;
            return Http.post(Config('api.token_url'), credentials);
          case 1:
            response = _context.sent;
            return _context.abrupt("return", new Promise(function (resolve) {
              return resolve(response);
            }));
          case 2:
            _context.prev = 2;
            _t = _context["catch"](0);
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              return reject(_t);
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 2]]);
    }))();
  },
  currentUser: function currentUser() {
    var currentUser = Http.get(Config('api.current_user_url'));
    return new Promise(function (resolve, reject) {
      currentUser.then(function (user) {
        return resolve(user.data);
      }).catch(function (error) {
        return reject(error);
      });
    });
  }
};